// map the following


const requirementMapping = {
  'ASUD-AIP': 'Disciplines - Artistic, Interpretive, & Philosophical Inquiry',
  'ASUD-CMP': 'Disciplines - Chemical, Mathematical, and Physical Universe',
  'ASUD-CSW': 'Disciplines - Cultures & Societies of the World',
  'ASUR-R21C1': 'Literacies - First Writing Requirement',
  'ASUD-HP': 'Disciplines - Historical Perspectives',
  'ASUD-LS': 'Disciplines - Living Systems',
  'ASUQ-QCD': 'Literacies - Quantification, Computation, & Data Analysis',
  'ASUD-SS': 'Disciplines - Science and Society',
  'ASUR-R21C2': 'Literacies - Second Writing Requirement',
  'ASUD-SES': 'Disciplines - Social & Economic Systems',
  'ASUW-WL': 'Literacies - World Languages',
};

export { requirementMapping };